import upperFirst from 'lodash/upperFirst'
import { compose, withState, lifecycle, setDisplayName } from 'recompose'
import withStatus from 'hocs/bases/withStatus'

const withFetchResource = ({
  resourceName = 'resource',
  getInitialResource = () => ({}),
  getResourceId = () => '',
  getAction = () => Promise.resolve,
  getSuccessData = (data) => data,
  getOnSuccess = () => () => {},
  fetchPredicate = () => true,
}) => {
  const ResourceName = upperFirst(resourceName)
  return compose(
    setDisplayName(ResourceName),
    withState(resourceName, 'setResource', getInitialResource),
    withStatus({
      actionName: `fetch${ResourceName}`,
      statusName: `fetch${ResourceName}Status`,
      getAction,
      getRequestMessage: () => `Finding ${ResourceName}...`,
      getOnSuccess: (props) => (data) => {
        console.log('data from api: ', data)
        getOnSuccess(props)(getSuccessData(data))
        return props.setResource(getSuccessData(data))
      },
    }),
    lifecycle({
      componentDidMount() {
        const { [`fetch${ResourceName}`]: fetchResource, ...props } = this.props
        const resourceId = getResourceId(props)
        // always fetch Resource
        // no need to provide resourceId if action does not need it
        if (fetchPredicate(props)) {
          fetchResource(resourceId)
        }
      },
    }),
  )
}

export default withFetchResource



// WEBPACK FOOTER //
// ./src/hocs/bases/withFetchResource.js